import { createContext } from "react";
const ByteMiniWebDashboardContext = createContext({});
export default ByteMiniWebDashboardContext;
